var map = {
	"./email.svg": 75876,
	"./github.svg": 38401,
	"./instagram.svg": 80152,
	"./linkedin.svg": 90978,
	"./slack.svg": 62732,
	"./twitter.svg": 63297,
	"./whatsapp.svg": 28654,
	"./x.svg": 89212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97774;